
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-29a4a2fc&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AnnounceTips.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AnnounceTips.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-29a4a2fc!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AnnounceTips.vue"),
  /* scopeId */
  "data-v-29a4a2fc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/anchor/helpCenter/AnnounceTips.vue
// module id = 364
// module chunks = 0